import Vue from "vue";
import VueRouter from "vue-router";
import NotFound from '@/views/NotFound';
import payResult from "@/views/PayResult"
import Page from "@/views/page/index.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Page",
    component: Page,
  },
  {
    path: "/atmResult",
    name: "atmResult",
    component: payResult,
  },
  {
    path: '/404',
    component: NotFound
  },
  {
    path: '*',
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior() {
    //x代表横坐标，y代表纵坐标
    return { x: 0, y: 0 };
  }
});

export default router;
